(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["urbx-bestsellers-product-rail"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-urbx-product-rail]';

    const initialiseRail = (root) => {
      if (!root || root.dataset.urbxRailInitialised === 'true') return;

      const scroller = root.querySelector('[data-rail-scroller]');
      const previous = root.querySelector('[data-rail-previous]');
      const next = root.querySelector('[data-rail-next]');
      const progress = root.querySelector('[data-rail-progress]');

      if (!scroller || !previous || !next || !progress) return;

      root.dataset.urbxRailInitialised = 'true';

      const maximumScroll = () => Math.max(scroller.scrollWidth - scroller.clientWidth, 0);

      const updateState = () => {
        const maximum = maximumScroll();
        const position = Math.max(0, Math.min(scroller.scrollLeft, maximum));
        const staticRail = maximum <= 2;
        const visibleRatio = scroller.scrollWidth > 0 ? scroller.clientWidth / scroller.scrollWidth : 1;
        const travelRatio = maximum > 0 ? position / maximum : 0;
        const progressScale = Math.min(1, visibleRatio + (1 - visibleRatio) * travelRatio);

        previous.disabled = staticRail || position <= 2;
        next.disabled = staticRail || position >= maximum - 2;
        root.classList.toggle('urbx-product-rail--static', staticRail);
        progress.style.transform = `scaleX(${progressScale})`;
      };

      const move = (direction) => {
        const amount = Math.max(scroller.clientWidth * 0.82, 240);
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        scroller.scrollBy({
          left: amount * direction,
          behavior: reduceMotion ? 'auto' : 'smooth'
        });
      };

      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      scroller.addEventListener('scroll', updateState, { passive: true });

      if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(updateState);
        resizeObserver.observe(scroller);
        const track = scroller.querySelector('.urbx-product-rail__track');
        if (track) resizeObserver.observe(track);
      } else {
        window.addEventListener('resize', updateState, { passive: true });
      }

      updateState();
    };

    const initialiseAll = (scope = document) => {
      scope.querySelectorAll(selector).forEach(initialiseRail);
      if (scope.matches && scope.matches(selector)) initialiseRail(scope);
    };

    initialiseAll();

    document.addEventListener('shopify:section:load', (event) => {
      initialiseAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["urbx-cinematic-slideshow"] && !Shopify.designMode) return;
  try {
    
  class UrbxCinematicSlider extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.slides = Array.from(this.querySelectorAll('[data-urbx-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.previousButton = this.querySelector('[data-previous]');
      this.nextButton = this.querySelector('[data-next]');
      this.toggleButton = this.querySelector('[data-toggle]');
      this.status = this.querySelector('[data-status]');
      this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.speed = Number(this.dataset.speed) || 5000;
      this.autoplayEnabled = this.dataset.autoplay === 'true';
      this.userPaused = false;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.previousHandler = () => this.show(this.index - 1, true);
      this.nextHandler = () => this.show(this.index + 1, true);
      this.toggleHandler = () => this.toggleAutoplay();
      this.keyHandler = (event) => this.handleKeydown(event);
      this.enterHandler = () => this.stop();
      this.leaveHandler = () => this.start();
      this.visibilityHandler = () => document.hidden ? this.stop() : this.start();
      this.motionHandler = () => this.start();
      this.blockSelectHandler = (event) => this.selectThemeBlock(event);
      this.previousButton?.addEventListener('click', this.previousHandler);
      this.nextButton?.addEventListener('click', this.nextHandler);
      this.toggleButton?.addEventListener('click', this.toggleHandler);
      this.addEventListener('keydown', this.keyHandler);
      this.addEventListener('mouseenter', this.enterHandler);
      this.addEventListener('mouseleave', this.leaveHandler);
      this.addEventListener('focusin', this.enterHandler);
      this.addEventListener('focusout', this.leaveHandler);
      document.addEventListener('visibilitychange', this.visibilityHandler);
      document.addEventListener('shopify:block:select', this.blockSelectHandler);
      this.reducedMotion.addEventListener('change', this.motionHandler);
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.show(Number(dot.dataset.dot), true));
      });
      this.show(this.index, false);
      this.start();
    }

    disconnectedCallback() {
      this.stop();
      this.previousButton?.removeEventListener('click', this.previousHandler);
      this.nextButton?.removeEventListener('click', this.nextHandler);
      this.toggleButton?.removeEventListener('click', this.toggleHandler);
      this.removeEventListener('keydown', this.keyHandler);
      this.removeEventListener('mouseenter', this.enterHandler);
      this.removeEventListener('mouseleave', this.leaveHandler);
      this.removeEventListener('focusin', this.enterHandler);
      this.removeEventListener('focusout', this.leaveHandler);
      document.removeEventListener('visibilitychange', this.visibilityHandler);
      document.removeEventListener('shopify:block:select', this.blockSelectHandler);
      this.reducedMotion?.removeEventListener('change', this.motionHandler);
    }

    show(nextIndex, announce) {
      if (this.slides.length === 0) return;
      const normalizedIndex = (nextIndex + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === normalizedIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.toggleAttribute('inert', !active);
      });
      this.dots.forEach((dot, dotIndex) => {
        const active = dotIndex === normalizedIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', String(active));
      });
      this.index = normalizedIndex;
      if (announce && this.status) {
        this.status.textContent = this.dots[normalizedIndex]?.getAttribute('aria-label') || '';
      }
      this.restart();
    }

    restart() {
      this.stop();
      this.start();
    }

    start() {
      this.stop();
      if (!this.autoplayEnabled || this.userPaused || this.reducedMotion.matches || this.slides.length < 2 || document.hidden) return;
      if (this.matches(':hover') || this.contains(document.activeElement)) return;
      this.timer = window.setInterval(() => this.show(this.index + 1, false), this.speed);
    }

    stop() {
      if (this.timer) window.clearInterval(this.timer);
      this.timer = null;
    }

    toggleAutoplay() {
      this.userPaused = !this.userPaused;
      const icon = this.toggleButton?.querySelector('[data-toggle-icon]');
      if (this.toggleButton) {
        const label = this.userPaused ? this.toggleButton.dataset.playLabel : this.toggleButton.dataset.pauseLabel;
        this.toggleButton.setAttribute('aria-label', label || '');
      }
      if (icon) icon.textContent = this.userPaused ? '\u25B6' : '\u275A\u275A';
      if (this.userPaused) this.stop(); else this.start();
    }

    handleKeydown(event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.show(this.index - 1, true);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.show(this.index + 1, true);
      }
    }

    selectThemeBlock(event) {
      const selectedSlide = event.target.closest('[data-urbx-slide]');
      if (!selectedSlide || !this.contains(selectedSlide)) return;
      const selectedIndex = this.slides.indexOf(selectedSlide);
      if (selectedIndex >= 0) {
        this.userPaused = true;
        this.show(selectedIndex, false);
      }
    }
  }

  if (!customElements.get('urbx-cinematic-slider')) {
    customElements.define('urbx-cinematic-slider', UrbxCinematicSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["urbx-collection-story-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-urbx-collection-story]';

    const initialise = (root) => {
      if (!root || root.dataset.storyInitialised === 'true') return;

      root.dataset.storyInitialised = 'true';

      const elements = root.querySelectorAll('[data-story-reveal]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reducedMotion || !('IntersectionObserver' in window)) {
        elements.forEach((element) => element.classList.add('is-visible'));
        return;
      }

      root.classList.add('is-motion-ready');

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            const delay = entry.target.classList.contains('urbx-collection-story__content') ? 120 : 0;
            window.setTimeout(() => entry.target.classList.add('is-visible'), delay);
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
      );

      elements.forEach((element) => observer.observe(element));
    };

    const initialiseAll = (scope = document) => {
      scope.querySelectorAll(selector).forEach(initialise);
      if (scope.matches && scope.matches(selector)) initialise(scope);
    };

    initialiseAll();

    document.addEventListener('shopify:section:load', (event) => {
      initialiseAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["urbx-complete-the-look"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('urbx-complete-look')) {
    class UrbxCompleteLook extends HTMLElement {
      connectedCallback() {
        this.status = this.querySelector('[data-look-status]');
        this.addedLabel = this.dataset.addedLabel || 'Added';
        this.loadingLabel = this.dataset.loadingLabel || 'Adding';
        this.errorLabel = this.dataset.errorLabel || 'Unable to add this item';
        this.buttons = Array.from(this.querySelectorAll('[data-look-quick-add]'));

        this.buttons.forEach((button) => {
          button.addEventListener('click', () => this.addToCart(button));
        });

        this.setupReveal();
      }

      setupReveal() {
        const items = Array.from(this.querySelectorAll('[data-look-reveal]'));

        if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          items.forEach((item) => item.classList.add('is-visible'));
          return;
        }

        this.classList.add('is-ready');

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.12 });

        items.forEach((item) => observer.observe(item));
      }

      async addToCart(button) {
        const variantId = Number(button.dataset.variantId);
        const label = button.querySelector('[data-look-action-label]');
        const defaultLabel = button.dataset.defaultLabel || label.textContent;

        if (!variantId || button.disabled) return;

        button.disabled = true;
        button.classList.add('is-loading');
        label.textContent = this.loadingLabel;

        try {
          const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              items: [{ id: variantId, quantity: 1 }]
            })
          });

          if (!response.ok) {
            const payload = await response.json().catch(() => ({}));
            throw new Error(payload.description || this.errorLabel);
          }

          const payload = await response.json();
          button.classList.remove('is-loading');
          button.classList.add('is-added');
          label.textContent = this.addedLabel;
          this.announce(this.addedLabel);

          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:updated', {
            bubbles: true,
            detail: { source: 'urbx-complete-look', payload }
          }));

          await this.refreshCartCount(root);

          window.setTimeout(() => {
            button.classList.remove('is-added');
            label.textContent = defaultLabel;
            button.disabled = false;
          }, 1600);
        } catch (error) {
          button.classList.remove('is-loading');
          label.textContent = defaultLabel;
          button.disabled = false;
          this.announce(error.message || this.errorLabel);
        }
      }

      async refreshCartCount(root) {
        try {
          const response = await fetch(`${root}cart.js`, {
            headers: { Accept: 'application/json' }
          });

          if (!response.ok) return;

          const cart = await response.json();
          const countTargets = document.querySelectorAll('[data-cart-count], [data-cart-count-bubble], .cart-count-bubble span');
          countTargets.forEach((target) => {
            target.textContent = cart.item_count;
            target.removeAttribute('hidden');
          });
        } catch (error) {
          return;
        }
      }

      announce(message) {
        if (!this.status) return;
        this.status.textContent = '';
        window.requestAnimationFrame(() => {
          this.status.textContent = message;
        });
      }
    }

    customElements.define('urbx-complete-look', UrbxCompleteLook);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["urbx-featured-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-urbx-featured-products]';

    const initialise = (root) => {
      if (!root || root.dataset.featuredProductsInitialised === 'true') return;

      root.dataset.featuredProductsInitialised = 'true';

      const grid = root.querySelector('[data-featured-grid]');
      const cards = Array.from(root.querySelectorAll('[data-featured-card]'));
      const previous = root.querySelector('[data-featured-previous]');
      const next = root.querySelector('[data-featured-next]');
      const controls = root.querySelector('.urbx-featured-products__controls');
      const progress = root.querySelector('[data-featured-progress]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let scrollFrame = null;

      const updateCarousel = () => {
        if (!grid) return;

        const maximumScroll = Math.max(0, grid.scrollWidth - grid.clientWidth);
        const canScroll = maximumScroll > 2;
        const ratio = maximumScroll > 0 ? grid.scrollLeft / maximumScroll : 1;
        const visibleRatio = Math.min(1, grid.clientWidth / Math.max(grid.scrollWidth, 1));

        if (controls) controls.hidden = !canScroll;

        if (progress) {
          const progressScale = Math.min(1, visibleRatio + ratio * (1 - visibleRatio));
          progress.style.transform = `scaleX(${progressScale})`;
        }

        if (previous) previous.disabled = grid.scrollLeft <= 2;
        if (next) next.disabled = grid.scrollLeft >= maximumScroll - 2;
      };

      const scrollByCard = (direction) => {
        if (!grid || cards.length === 0) return;

        const cardWidth = cards[0].getBoundingClientRect().width;
        const gap = Number.parseFloat(window.getComputedStyle(grid).columnGap) || 0;
        grid.scrollBy({
          left: direction * (cardWidth + gap),
          behavior: reducedMotion ? 'auto' : 'smooth'
        });
      };

      previous?.addEventListener('click', () => scrollByCard(-1));
      next?.addEventListener('click', () => scrollByCard(1));

      grid?.addEventListener(
        'scroll',
        () => {
          if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
          scrollFrame = window.requestAnimationFrame(updateCarousel);
        },
        { passive: true }
      );

      const handleResize = () => {
        updateCarousel();
      };

      window.addEventListener('resize', handleResize, { passive: true });
      updateCarousel();

      const revealElements = root.querySelectorAll('[data-featured-reveal]');

      if (reducedMotion || !('IntersectionObserver' in window)) {
        revealElements.forEach((element) => element.classList.add('is-visible'));
      } else {
        root.classList.add('is-motion-ready');

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            });
          },
          { threshold: 0.08, rootMargin: '0px 0px -6% 0px' }
        );

        revealElements.forEach((element, index) => {
          element.style.transitionDelay = `${Math.min(index, 5) * 65}ms`;
          observer.observe(element);
        });
      }
    };

    const initialiseAll = (scope = document) => {
      scope.querySelectorAll(selector).forEach(initialise);
      if (scope.matches && scope.matches(selector)) initialise(scope);
    };

    initialiseAll();

    document.addEventListener('shopify:section:load', (event) => {
      initialiseAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["urbx-gender-collections"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('urbx-gender-collections')) {
    customElements.define(
      'urbx-gender-collections',
      class UrbxGenderCollections extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.tabs = Array.from(this.querySelectorAll('[data-urbx-tab]'));
          this.panels = Array.from(this.querySelectorAll('[data-urbx-panel]'));

          this.tabs.forEach((tab) => {
            tab.addEventListener('click', () => this.activate(tab.dataset.urbxTab));
            tab.addEventListener('keydown', (event) => this.handleKeys(event));
          });

          this.addEventListener('shopify:block:select', (event) => {
            const card = event.target.closest('[data-urbx-card-tab]');
            if (card) this.activate(card.dataset.urbxCardTab);
          });

          this.activate(this.dataset.initialTab, false);
        }

        activate(name, animate = true) {
          const selectedTab = this.tabs.find((tab) => tab.dataset.urbxTab === name && !tab.disabled);
          if (!selectedTab) return;

          const update = () => {
            this.tabs.forEach((tab) => {
              const selected = tab === selectedTab;
              tab.setAttribute('aria-selected', selected ? 'true' : 'false');
              tab.tabIndex = selected ? 0 : -1;
            });

            this.panels.forEach((panel) => {
              panel.hidden = panel.dataset.urbxPanel !== name;
            });
          };

          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (animate && document.startViewTransition && !reduceMotion) {
            document.startViewTransition(update);
          } else {
            update();
          }
        }

        handleKeys(event) {
          const enabledTabs = this.tabs.filter((tab) => !tab.disabled);
          const currentIndex = enabledTabs.indexOf(event.currentTarget);
          let nextIndex = currentIndex;

          if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % enabledTabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + enabledTabs.length) % enabledTabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = enabledTabs.length - 1;
          if (nextIndex === currentIndex) return;

          event.preventDefault();
          enabledTabs[nextIndex].focus();
          this.activate(enabledTabs[nextIndex].dataset.urbxTab);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["urbx-global-motion"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const controllerSelector = '[data-urbx-motion-controller]';
    const root = document.documentElement;
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const desktopQuery = window.matchMedia('(min-width: 750px) and (pointer: fine)');

    class UrbxMotionLayer {
      constructor(controller) {
        this.controller = controller;
        this.config = this.readConfig(controller);
        this.revealObserver = null;
        this.resizeObserver = null;
        this.sections = [];
        this.parallaxItems = [];
        this.pinSection = null;
        this.pinContent = null;
        this.frame = 0;
        this.smoothFrame = 0;
        this.smoothTarget = window.scrollY;
        this.smoothCurrent = window.scrollY;
        this.smoothRunning = false;
        this.lastViewportWidth = window.innerWidth;
        this.destroyed = false;
        this.onViewportUpdate = this.onViewportUpdate.bind(this);
        this.onWheel = this.onWheel.bind(this);
        this.onNativeScroll = this.onNativeScroll.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
      }

      readConfig(element) {
        const data = element.dataset;
        return {
          enabled: data.enabled === 'true',
          homeOnly: data.homeOnly === 'true',
          pageType: data.pageType,
          scope: data.scope || 'urbx',
          revealStyle: data.revealStyle || 'clip',
          revealDistance: Number(data.revealDistance) || 36,
          revealDuration: Number(data.revealDuration) || 850,
          revealOnce: data.revealOnce === 'true',
          smoothScroll: data.smoothScroll === 'true',
          smoothness: (Number(data.smoothness) || 14) / 100,
          wheelMultiplier: Number(data.wheelMultiplier) || 1,
          parallax: data.parallax === 'true',
          parallaxStrength: Number(data.parallaxStrength) || 30,
          pinHero: data.pinHero === 'true',
          pinDistance: Number(data.pinDistance) || 50,
          pinTop: Number(data.pinTop) || 0,
          mobileReveals: data.mobileReveals === 'true'
        };
      }

      init() {
        if (!this.config.enabled) return;
        if (this.config.homeOnly && this.config.pageType !== 'index') return;

        root.classList.add('urbx-motion-runtime');
        root.style.setProperty('--urbx-motion-distance', `${this.config.revealDistance}px`);
        root.style.setProperty('--urbx-motion-duration', `${this.config.revealDuration}ms`);

        if (reducedMotionQuery.matches) {
          this.revealImmediately();
          return;
        }

        this.setupSections();
        this.setupParallax();
        this.setupPinnedHero();
        this.setupSmoothScroll();

        window.addEventListener('scroll', this.onViewportUpdate, { passive: true });
        window.addEventListener('resize', this.onResize, { passive: true });
        window.addEventListener('keydown', this.onKeyDown);
        this.onViewportUpdate();
      }

      getMainSections() {
        const main = document.querySelector('main') || document.querySelector('#MainContent');
        if (!main) return [];

        const candidates = Array.from(main.querySelectorAll('.shopify-section'));
        return candidates.filter((section) => {
          if (section.classList.contains('urbx-global-motion-section')) return false;
          if (section.classList.contains('section-urbx-luxury-header')) return false;
          if (section.classList.contains('section-urbx-luxury-footer')) return false;
          if (this.config.scope === 'all') return true;
          if (section.className.includes('urbx')) return true;
          return Boolean(section.querySelector('[class^="urbx-"], [class*=" urbx-"]'));
        });
      }

      setupSections() {
        this.sections = this.getMainSections();
        const mobileShouldReveal = window.innerWidth >= 750 || this.config.mobileReveals;

        if (!mobileShouldReveal || !('IntersectionObserver' in window)) {
          this.sections.forEach((section) => this.makeVisible(section));
          return;
        }

        this.revealObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.makeVisible(entry.target);
                if (this.config.revealOnce) this.revealObserver.unobserve(entry.target);
              } else if (!this.config.revealOnce && entry.boundingClientRect.top > 0) {
                this.makePending(entry.target);
              }
            });
          },
          { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
        );

        this.sections.forEach((section, index) => {
          section.classList.add('urbx-motion-target');
          section.dataset.urbxRevealStyle = this.config.revealStyle;
          section.style.setProperty('--urbx-motion-distance', `${this.config.revealDistance}px`);
          section.style.setProperty('--urbx-motion-duration', `${this.config.revealDuration}ms`);

          const rect = section.getBoundingClientRect();
          if (index === 0 || rect.top < window.innerHeight * 0.92) {
            this.makeVisible(section);
            if (!this.config.revealOnce) this.revealObserver.observe(section);
          } else {
            this.makePending(section);
            this.revealObserver.observe(section);
          }
        });
      }

      makePending(section) {
        section.classList.remove('urbx-motion-visible');
        section.classList.add('urbx-motion-pending');
      }

      makeVisible(section) {
        section.classList.remove('urbx-motion-pending');
        section.classList.add('urbx-motion-visible');
      }

      revealImmediately() {
        this.getMainSections().forEach((section) => {
          section.classList.add('urbx-motion-target', 'urbx-motion-visible');
          section.classList.remove('urbx-motion-pending');
        });
      }

      setupParallax() {
        if (!this.config.parallax || !desktopQuery.matches) return;

        const selectors = [
          '.urbx-cinematic__media img',
          '.urbx-cinematic__media video',
          '.urbx-editorial__media img',
          '.urbx-products__media img',
          '.urbx-manifesto__figure img'
        ].join(',');

        this.parallaxItems = Array.from(document.querySelectorAll(selectors));
        this.parallaxItems.forEach((item) => item.classList.add('urbx-motion-parallax'));
      }

      setupPinnedHero() {
        if (!this.config.pinHero || !desktopQuery.matches || window.Shopify?.designMode) return;

        const cinematic = document.querySelector('main .urbx-cinematic');
        if (!cinematic) return;

        const wrapper = cinematic.closest('.shopify-section');
        if (!wrapper) return;

        const measuredHeight = cinematic.getBoundingClientRect().height;
        if (measuredHeight < 300) return;

        this.pinSection = wrapper;
        this.pinContent = cinematic;
        wrapper.classList.add('urbx-motion-pin-section');
        wrapper.style.setProperty('--urbx-pin-height', `${measuredHeight}px`);
        wrapper.style.setProperty('--urbx-pin-extra', `${this.config.pinDistance}vh`);
        wrapper.style.setProperty('--urbx-pin-top', `${this.config.pinTop}px`);
        this.updatePinnedHero();
      }

      setupSmoothScroll() {
        if (!this.config.smoothScroll || !desktopQuery.matches || window.Shopify?.designMode) return;
        root.classList.add('urbx-motion-smooth');
        this.smoothTarget = window.scrollY;
        this.smoothCurrent = window.scrollY;
        window.addEventListener('wheel', this.onWheel, { passive: false });
        window.addEventListener('scroll', this.onNativeScroll, { passive: true });
      }

      shouldKeepNativeScroll(target) {
        if (!(target instanceof Element)) return false;
        if (target.closest('input, textarea, select, option, [contenteditable="true"], [data-urbx-native-scroll]')) return true;

        let element = target;
        while (element && element !== document.body) {
          const styles = window.getComputedStyle(element);
          const scrollable = /(auto|scroll)/.test(styles.overflowY);
          if (scrollable && element.scrollHeight > element.clientHeight + 2) return true;
          element = element.parentElement;
        }
        return false;
      }

      normalizeWheel(event) {
        if (event.deltaMode === 1) return event.deltaY * 16;
        if (event.deltaMode === 2) return event.deltaY * window.innerHeight;
        return event.deltaY;
      }

      onWheel(event) {
        if (event.ctrlKey || event.metaKey || this.shouldKeepNativeScroll(event.target)) return;
        event.preventDefault();

        const maximum = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
        const delta = this.normalizeWheel(event) * this.config.wheelMultiplier;
        this.smoothTarget = Math.min(maximum, Math.max(0, this.smoothTarget + delta));

        if (!this.smoothRunning) {
          this.smoothRunning = true;
          this.runSmoothScroll();
        }
      }

      runSmoothScroll() {
        if (!this.smoothRunning || this.destroyed) return;

        const distance = this.smoothTarget - this.smoothCurrent;
        this.smoothCurrent += distance * this.config.smoothness;

        if (Math.abs(distance) < 0.35) {
          this.smoothCurrent = this.smoothTarget;
          this.smoothRunning = false;
        }

        window.scrollTo(0, this.smoothCurrent);
        if (this.smoothRunning) this.smoothFrame = requestAnimationFrame(() => this.runSmoothScroll());
      }

      onNativeScroll() {
        if (!this.smoothRunning) {
          this.smoothTarget = window.scrollY;
          this.smoothCurrent = window.scrollY;
        }
      }

      onKeyDown() {
        this.stopSmoothScroll();
      }

      stopSmoothScroll() {
        if (this.smoothFrame) cancelAnimationFrame(this.smoothFrame);
        this.smoothFrame = 0;
        this.smoothRunning = false;
        this.smoothTarget = window.scrollY;
        this.smoothCurrent = window.scrollY;
      }

      onViewportUpdate() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.updateParallax();
          this.updatePinnedHero();
        });
      }

      updateParallax() {
        if (!this.parallaxItems.length || !desktopQuery.matches) return;

        const viewportHeight = window.innerHeight;
        this.parallaxItems.forEach((item) => {
          const rect = item.getBoundingClientRect();
          if (rect.bottom < -100 || rect.top > viewportHeight + 100) return;
          const center = rect.top + rect.height / 2;
          const progress = (center - viewportHeight / 2) / (viewportHeight + rect.height);
          const offset = Math.max(-this.config.parallaxStrength, Math.min(this.config.parallaxStrength, progress * -this.config.parallaxStrength * 2));
          item.style.setProperty('--urbx-parallax-y', `${offset.toFixed(2)}px`);
        });
      }

      updatePinnedHero() {
        if (!this.pinSection || !desktopQuery.matches) return;

        const rect = this.pinSection.getBoundingClientRect();
        const extra = Math.max(1, window.innerHeight * (this.config.pinDistance / 100));
        const progress = Math.max(0, Math.min(1, (this.config.pinTop - rect.top) / extra));
        const contentY = progress * -34;
        const opacity = 1 - Math.max(0, progress - 0.55) / 0.45;
        const scale = 1 + progress * 0.07;
        const shade = Math.max(0, progress - 0.35) * 0.9;

        this.pinSection.style.setProperty('--urbx-pin-content-y', `${contentY.toFixed(2)}px`);
        this.pinSection.style.setProperty('--urbx-pin-content-opacity', Math.max(0, opacity).toFixed(3));
        this.pinSection.style.setProperty('--urbx-pin-media-scale', scale.toFixed(4));
        this.pinSection.style.setProperty('--urbx-pin-shade', Math.min(0.6, shade).toFixed(3));
      }

      onResize() {
        if (Math.abs(window.innerWidth - this.lastViewportWidth) < 2) return;
        this.lastViewportWidth = window.innerWidth;
        this.stopSmoothScroll();
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => window.URBXMotion?.boot(), 180);
      }

      destroy() {
        this.destroyed = true;
        this.stopSmoothScroll();
        if (this.frame) cancelAnimationFrame(this.frame);
        if (this.resizeTimer) clearTimeout(this.resizeTimer);
        if (this.revealObserver) this.revealObserver.disconnect();
        if (this.resizeObserver) this.resizeObserver.disconnect();

        window.removeEventListener('wheel', this.onWheel);
        window.removeEventListener('scroll', this.onNativeScroll);
        window.removeEventListener('scroll', this.onViewportUpdate);
        window.removeEventListener('resize', this.onResize);
        window.removeEventListener('keydown', this.onKeyDown);

        this.sections.forEach((section) => {
          section.classList.remove('urbx-motion-target', 'urbx-motion-pending', 'urbx-motion-visible');
          section.removeAttribute('data-urbx-reveal-style');
          section.style.removeProperty('--urbx-motion-distance');
          section.style.removeProperty('--urbx-motion-duration');
        });

        this.parallaxItems.forEach((item) => {
          item.classList.remove('urbx-motion-parallax');
          item.style.removeProperty('--urbx-parallax-y');
        });

        if (this.pinSection) {
          this.pinSection.classList.remove('urbx-motion-pin-section');
          [
            '--urbx-pin-height',
            '--urbx-pin-extra',
            '--urbx-pin-top',
            '--urbx-pin-content-y',
            '--urbx-pin-content-opacity',
            '--urbx-pin-media-scale',
            '--urbx-pin-shade'
          ].forEach((property) => this.pinSection.style.removeProperty(property));
        }

        root.classList.remove('urbx-motion-runtime', 'urbx-motion-smooth');
        root.style.removeProperty('--urbx-motion-distance');
        root.style.removeProperty('--urbx-motion-duration');
      }
    }

    const boot = () => {
      const controller = document.querySelector(controllerSelector);
      if (window.URBXMotion?.instance) window.URBXMotion.instance.destroy();

      window.URBXMotion = { boot, instance: null };
      if (!controller) return;

      const instance = new UrbxMotionLayer(controller);
      window.URBXMotion.instance = instance;
      instance.init();
    };

    const scheduleBoot = () => requestAnimationFrame(boot);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', scheduleBoot);
    document.addEventListener('shopify:section:unload', scheduleBoot);
    document.addEventListener('shopify:section:reorder', scheduleBoot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["urbx-immersive-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-urbx-product-media]';

    const initialise = (root) => {
      if (!root || root.dataset.productMediaInitialised === 'true') return;

      root.dataset.productMediaInitialised = 'true';

      const grid = root.querySelector('[data-media-grid]');
      const items = Array.from(root.querySelectorAll('[data-media-item]'));
      const thumbnails = Array.from(root.querySelectorAll('[data-media-thumbnail]'));
      const current = root.querySelector('[data-media-current]');
      const previous = root.querySelector('[data-media-previous]');
      const next = root.querySelector('[data-media-next]');
      const productPanel = root.querySelector('[data-product-information-panel]');
      const productPanelInner = productPanel?.querySelector('.urbx-product-info-panel__inner');
      const productAvailability = root.querySelector('[data-product-availability]');
      const productAvailabilityText = root.querySelector('[data-product-availability-text]');
      const productSku = root.querySelector('[data-product-sku]');
      const productSkuRow = root.querySelector('[data-product-sku-row]');
      const productCurrentPrice = root.querySelector('[data-product-current-price]');
      const productComparePrice = root.querySelector('[data-product-compare-price]');
      const productSoldOutBadge = root.querySelector('[data-product-sold-out-badge]');
      const productSaleBadge = root.querySelector('[data-product-sale-badge]');
      const productSalePercentage = root.querySelector('[data-product-sale-percentage]');
      const selectedColor = root.querySelector('[data-selected-color]');
      const selectedSize = root.querySelector('[data-selected-size]');
      const colorInputs = Array.from(root.querySelectorAll('[data-color-swatch-input]'));
      const sizeInputs = Array.from(root.querySelectorAll('[data-size-option-input]'));
      const optionInputs = Array.from(root.querySelectorAll('[data-product-option-input]'));
      const variantDataElement = root.querySelector('[data-product-variant-data]');
      const sizeGuideDrawer = root.querySelector('[data-size-guide-drawer]');
      const sizeGuideOpenButtons = Array.from(root.querySelectorAll('[data-size-guide-open]'));
      const sizeGuideCloseButtons = Array.from(root.querySelectorAll('[data-size-guide-close]'));
      const deliveryReturnsDrawer = root.querySelector('[data-delivery-returns-drawer]');
      const deliveryReturnsOpenButtons = Array.from(root.querySelectorAll('[data-delivery-returns-open]'));
      const deliveryReturnsCloseButtons = Array.from(root.querySelectorAll('[data-delivery-returns-close]'));
      const stickyAddBar = root.querySelector('[data-sticky-add-bar]');
      const stickyAddForm = stickyAddBar?.querySelector('.urbx-sticky-add-bar__form');
      const stickyAddButton = stickyAddBar?.querySelector('[data-sticky-add-button]');
      const stickyAddButtonLabel = stickyAddBar?.querySelector('[data-sticky-add-button-label]');
      const stickyAddVariantInput = stickyAddBar?.querySelector('[data-sticky-add-variant-id]');
      const stickyAddQuantityInput = stickyAddBar?.querySelector('[data-sticky-quantity-input]');
      const stickyAddQuantityMinus = stickyAddBar?.querySelector('[data-sticky-quantity-minus]');
      const stickyAddQuantityPlus = stickyAddBar?.querySelector('[data-sticky-quantity-plus]');
      const stickyAddPrice = stickyAddBar?.querySelector('[data-sticky-add-price]');
      const stickyAddComparePrice = stickyAddBar?.querySelector('[data-sticky-add-compare-price]');
      const stickyAddColor = stickyAddBar?.querySelector('[data-sticky-add-color]');
      const stickyAddSize = stickyAddBar?.querySelector('[data-sticky-add-size]');
      const stickyAddImage = stickyAddBar?.querySelector('[data-sticky-add-image]');
      const stickyAddStatus = stickyAddBar?.querySelector('[data-sticky-add-status]');
      const mainPurchaseForm = root.querySelector('.urbx-product-info-panel__purchase-form');
      const mainAddButton = root.querySelector('[data-main-add-button]');
      const mainAddButtonLabel = root.querySelector('[data-main-add-button-label]');
      const mainPurchaseVariantInput = root.querySelector('[data-main-purchase-variant-id]');
      const mainPurchaseQuantityInput = root.querySelector('[data-main-purchase-quantity]');
      const mainBuyNow = root.querySelector('[data-main-buy-now]');
      const mainPurchaseStatus = root.querySelector('[data-main-purchase-status]');
      let variants = [];

      try {
        variants = variantDataElement ? JSON.parse(variantDataElement.textContent) : [];
      } catch (error) {
        console.warn('URBX product variants could not be parsed.', error);
      }

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const mobileQuery = window.matchMedia('(max-width: 749px)');
      const desktopPanelQuery = window.matchMedia('(min-width: 990px)');
      const isThemeEditor = Boolean(window.Shopify?.designMode);
      let activeIndex = Math.max(0, items.findIndex((item) => item.classList.contains('is-active')));
      let scrollFrame = null;
      let stickyPanelFrame = null;
      let stickyPanelResizeObserver = null;

      const updateStickyPanelMode = () => {
        if (!productPanel || !productPanelInner) return;

        if (stickyPanelFrame) window.cancelAnimationFrame(stickyPanelFrame);

        stickyPanelFrame = window.requestAnimationFrame(() => {
          const stickyEnabled = root.classList.contains('urbx-product-media--sticky-panel');
          const stickyOffsetValue = Number.parseFloat(
            window.getComputedStyle(root).getPropertyValue('--urbx-pm-sticky-offset')
          );
          const stickyOffset = Number.isFinite(stickyOffsetValue) ? stickyOffsetValue : 24;
          const availableHeight = Math.max(320, window.innerHeight - stickyOffset - 24);
          const panelHeight = Math.ceil(productPanelInner.getBoundingClientRect().height);
          const canStick = stickyEnabled && desktopPanelQuery.matches && panelHeight <= availableHeight;

          productPanel.classList.toggle('is-sticky-ready', canStick);
          productPanel.classList.toggle(
            'is-sticky-too-tall',
            stickyEnabled && desktopPanelQuery.matches && !canStick
          );
        });
      };

      window.addEventListener('resize', updateStickyPanelMode, { passive: true });

      if ('ResizeObserver' in window && productPanelInner) {
        stickyPanelResizeObserver = new ResizeObserver(updateStickyPanelMode);
        stickyPanelResizeObserver.observe(productPanelInner);
      }

      const getFallbackSwatchColor = (name) => {
        const value = String(name || '').trim().toLowerCase();

        if (value && window.CSS?.supports?.('color', value)) {
          return value;
        }

        let hash = 0;
        for (let index = 0; index < value.length; index += 1) {
          hash = value.charCodeAt(index) + ((hash << 5) - hash);
        }

        const hue = Math.abs(hash) % 360;
        return `hsl(${hue} 32% 56%)`;
      };

      root.querySelectorAll('[data-swatch-fallback]').forEach((swatch) => {
        swatch.style.setProperty('--urbx-swatch-color', getFallbackSwatchColor(swatch.dataset.swatchFallback));
      });

      const currentVariantId = Number(productPanel?.dataset.currentVariantId || 0);
      const initialVariant = variants.find((variant) => Number(variant.id) === currentVariantId) || variants[0];
      const selectedOptionValues = initialVariant?.options ? [...initialVariant.options] : [];

      const findVariant = (optionValues) =>
        variants.find(
          (variant) =>
            Array.isArray(variant.options) &&
            variant.options.length === optionValues.length &&
            variant.options.every((value, index) => value === optionValues[index])
        );

      const candidateVariantForInput = (input) => {
        const optionPosition = Number(input.dataset.optionPosition || 0);
        if (!optionPosition) return null;

        const candidateOptions = [...selectedOptionValues];
        candidateOptions[optionPosition - 1] = input.value;
        return findVariant(candidateOptions) || null;
      };

      const updateOptionAvailability = () => {
        optionInputs.forEach((input) => {
          const label = input.closest('label');
          const baseTitle = input.value || '';

          if (input.dataset.connectedProductUrl) {
            input.disabled = false;
            input.setAttribute('aria-disabled', 'false');
            label?.classList.remove('is-unavailable');
            label?.setAttribute('title', baseTitle);
            return;
          }

          const candidateVariant = candidateVariantForInput(input);
          const doesNotExist = !candidateVariant;
          const soldOut = candidateVariant?.available === false;
          const unavailable = doesNotExist || soldOut;

          input.disabled = doesNotExist;
          input.setAttribute('aria-disabled', doesNotExist ? 'true' : 'false');
          label?.classList.toggle('is-unavailable', unavailable);
          label?.setAttribute('title', unavailable ? `${baseTitle} — Sold out` : baseTitle);
        });
      };

      const dispatchVariantChange = (variant, input) => {
        if (!variant) return;

        root.dispatchEvent(
          new CustomEvent('variant:change', {
            bubbles: true,
            detail: {
              sectionId: root.dataset.sectionId,
              variant: {
                id: Number(variant.id),
                available: variant.available === true,
                sku: variant.sku || '',
                featured_media: variant.featuredMediaId ? { id: Number(variant.featuredMediaId) } : null
              },
              formattedPrice: variant.formattedPrice || '',
              formattedCompareAtPrice: variant.formattedCompareAtPrice || '',
              onSale: variant.onSale === true,
              salePercentage: variant.salePercentage ?? 0,
              selectedColor: colorInputs.find((colorInput) => colorInput.checked)?.value || '',
              selectedSize: sizeInputs.find((sizeInput) => sizeInput.checked)?.value || ''
            }
          })
        );

        root.querySelectorAll('form[action*="/cart/add"] [name="id"]').forEach((variantInput) => {
          variantInput.value = variant.id;
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        });

        if (window.history?.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }

        if (input?.dataset.connectedProductUrl) {
          const connectedUrl = new URL(input.dataset.connectedProductUrl, window.location.origin);
          connectedUrl.searchParams.set('variant', variant.id);
          window.location.assign(connectedUrl.toString());
        }
      };

      const selectProductOption = (input) => {
        if (!input || !input.checked || input.disabled) return;

        if (input.dataset.connectedProductUrl) {
          window.location.assign(input.dataset.connectedProductUrl);
          return;
        }

        const optionPosition = Number(input.dataset.optionPosition || 0);
        if (!optionPosition) return;

        selectedOptionValues[optionPosition - 1] = input.value;

        if (input.matches('[data-color-swatch-input]') && selectedColor) {
          selectedColor.textContent = input.value;
        }

        if (input.matches('[data-size-option-input]') && selectedSize) {
          selectedSize.textContent = input.value;
        }

        const variant = findVariant(selectedOptionValues);
        updateOptionAvailability();
        dispatchVariantChange(variant, input);
      };

      optionInputs.forEach((input) => {
        input.addEventListener('change', () => selectProductOption(input));
      });

      updateOptionAvailability();


      const setMainAddButtonState = (state, message = '') => {
        if (!mainAddButton || !mainAddButtonLabel) return;

        const labels = {
          default: mainAddButton.dataset.defaultLabel || 'Add to bag',
          loading: mainAddButton.dataset.loadingLabel || 'Adding…',
          added: mainAddButton.dataset.addedLabel || 'Added to bag',
          soldOut: mainAddButton.dataset.soldOutLabel || 'Sold out'
        };

        mainAddButton.classList.toggle('is-loading', state === 'loading');
        mainAddButton.disabled = state === 'loading' || state === 'soldOut';
        mainAddButtonLabel.textContent = labels[state] || labels.default;

        if (mainPurchaseStatus) {
          mainPurchaseStatus.textContent = message;
        }
      };

      const updateMainPurchaseActions = (variant) => {
        if (!variant) return;

        const soldOut = variant.available === false;
        if (mainPurchaseVariantInput) mainPurchaseVariantInput.value = variant.id || '';
        if (mainBuyNow) mainBuyNow.hidden = soldOut;
        setMainAddButtonState(soldOut ? 'soldOut' : 'default');
      };

      const setStickyButtonState = (state, message = '') => {
        if (!stickyAddButton || !stickyAddButtonLabel) return;

        const labels = {
          default: stickyAddButton.dataset.defaultLabel || 'Add to bag',
          loading: stickyAddButton.dataset.loadingLabel || 'Adding…',
          added: stickyAddButton.dataset.addedLabel || 'Added',
          soldOut: stickyAddButton.dataset.soldOutLabel || 'Sold out'
        };

        stickyAddButton.classList.toggle('is-loading', state === 'loading');
        stickyAddButton.disabled = state === 'loading' || state === 'soldOut';
        stickyAddButtonLabel.textContent = labels[state] || labels.default;

        if (stickyAddStatus) {
          stickyAddStatus.textContent = message;
        }
      };

      const updateStickyBar = (variant, detail = {}) => {
        if (!stickyAddBar || !variant) return;

        const soldOut = variant.available === false;
        if (stickyAddVariantInput) stickyAddVariantInput.value = variant.id || '';
        if (stickyAddPrice && detail.formattedPrice) stickyAddPrice.textContent = detail.formattedPrice;

        if (stickyAddComparePrice) {
          const comparePrice = detail.formattedCompareAtPrice || '';
          stickyAddComparePrice.textContent = comparePrice;
          stickyAddComparePrice.hidden = !comparePrice;
        }

        if (stickyAddColor && detail.selectedColor) stickyAddColor.textContent = detail.selectedColor;
        if (stickyAddSize && detail.selectedSize) stickyAddSize.textContent = detail.selectedSize;

        const mediaId = variant.featured_media?.id || detail.featuredMediaId;
        if (stickyAddImage && mediaId) {
          const mediaItem = items.find((item) => String(item.dataset.mediaId) === String(mediaId));
          const mediaImage = mediaItem?.querySelector('.urbx-product-media__image');
          const imageSource = mediaImage?.currentSrc || mediaImage?.src;
          if (imageSource) stickyAddImage.src = imageSource;
        }

        setStickyButtonState(soldOut ? 'soldOut' : 'default');
      };

      const updateCartCount = async () => {
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
            headers: { Accept: 'application/json' }
          });
          if (!response.ok) return;
          const cart = await response.json();
          const countTargets = document.querySelectorAll(
            '[data-cart-count], .cart-count-bubble span:first-child, #cart-icon-bubble .cart-count-bubble span:first-child'
          );
          countTargets.forEach((target) => {
            target.textContent = cart.item_count;
            target.closest('.cart-count-bubble')?.removeAttribute('hidden');
          });
        } catch (error) {
          console.warn('URBX cart count could not be refreshed.', error);
        }
      };

      mainAddButton?.addEventListener('click', async () => {
        if (mainAddButton.disabled || !mainPurchaseVariantInput?.value) return;

        const variantId = Number(mainPurchaseVariantInput.value);
        const quantity = Math.max(1, Math.floor(Number(mainPurchaseQuantityInput?.value) || 1));
        setMainAddButtonState('loading', 'Adding item to your bag.');

        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              items: [{ id: variantId, quantity }]
            })
          });

          const result = await response.json();
          if (!response.ok) {
            throw new Error(result.description || result.message || 'This item could not be added to your bag.');
          }

          setMainAddButtonState('added', `${quantity} item${quantity === 1 ? '' : 's'} added to your bag.`);
          await updateCartCount();

          document.dispatchEvent(
            new CustomEvent('cart:updated', {
              bubbles: true,
              detail: { source: 'urbx-main-product-form', variantId, quantity, result }
            })
          );
          document.dispatchEvent(
            new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: { source: 'urbx-main-product-form', variantId, quantity }
            })
          );

          window.setTimeout(() => {
            const currentVariant = variants.find(
              (variant) => Number(variant.id) === Number(mainPurchaseVariantInput.value)
            );
            setMainAddButtonState(currentVariant?.available === false ? 'soldOut' : 'default');
          }, 1800);
        } catch (error) {
          setMainAddButtonState('default', error.message || 'This item could not be added to your bag.');
        }
      });

      if (stickyAddBar) {
        const stickyTriggerOffset = Number(root.dataset.stickyAddTriggerOffset || 420);
        let stickyScrollFrame = null;

        const updateStickyVisibility = () => {
          const rootBounds = root.getBoundingClientRect();
          const sectionTop = rootBounds.top + window.scrollY;
          const pastTrigger = window.scrollY >= sectionTop + stickyTriggerOffset;
          const sectionStillRelevant = rootBounds.bottom > 0;
          const visible = pastTrigger && sectionStillRelevant;

          stickyAddBar.classList.toggle('is-visible', visible);
          stickyAddBar.setAttribute('aria-hidden', visible ? 'false' : 'true');
        };

        const queueStickyVisibilityUpdate = () => {
          if (stickyScrollFrame) window.cancelAnimationFrame(stickyScrollFrame);
          stickyScrollFrame = window.requestAnimationFrame(updateStickyVisibility);
        };

        window.addEventListener('scroll', queueStickyVisibilityUpdate, { passive: true });
        window.addEventListener('resize', queueStickyVisibilityUpdate);
        updateStickyVisibility();

        const normaliseQuantity = () => {
          if (!stickyAddQuantityInput) return 1;
          const quantity = Math.max(1, Math.floor(Number(stickyAddQuantityInput.value) || 1));
          stickyAddQuantityInput.value = quantity;
          return quantity;
        };

        stickyAddQuantityMinus?.addEventListener('click', () => {
          if (!stickyAddQuantityInput) return;
          stickyAddQuantityInput.value = Math.max(1, normaliseQuantity() - 1);
        });

        stickyAddQuantityPlus?.addEventListener('click', () => {
          if (!stickyAddQuantityInput) return;
          stickyAddQuantityInput.value = normaliseQuantity() + 1;
        });

        stickyAddQuantityInput?.addEventListener('change', normaliseQuantity);

        stickyAddForm?.addEventListener('submit', async (event) => {
          event.preventDefault();
          if (!stickyAddButton || stickyAddButton.disabled || !stickyAddVariantInput?.value) return;

          const variantId = Number(stickyAddVariantInput.value);
          const quantity = normaliseQuantity();
          setStickyButtonState('loading', 'Adding item to your bag.');

          try {
            const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                items: [{ id: variantId, quantity }]
              })
            });

            const result = await response.json();
            if (!response.ok) {
              throw new Error(result.description || result.message || 'This item could not be added to your bag.');
            }

            setStickyButtonState('added', `${quantity} item${quantity === 1 ? '' : 's'} added to your bag.`);
            await updateCartCount();

            document.dispatchEvent(
              new CustomEvent('cart:updated', {
                bubbles: true,
                detail: { source: 'urbx-sticky-add-bar', variantId, quantity, result }
              })
            );
            document.dispatchEvent(
              new CustomEvent('cart:refresh', {
                bubbles: true,
                detail: { source: 'urbx-sticky-add-bar', variantId, quantity }
              })
            );

            window.setTimeout(() => {
              const currentVariant = variants.find(
                (variant) => Number(variant.id) === Number(stickyAddVariantInput.value)
              );
              setStickyButtonState(currentVariant?.available === false ? 'soldOut' : 'default');
            }, 1800);
          } catch (error) {
            setStickyButtonState('default', error.message || 'This item could not be added to your bag.');
          }
        });
      }

      if (initialVariant) {
        updateMainPurchaseActions(initialVariant);
        updateStickyBar(initialVariant, {
          formattedPrice: initialVariant.formattedPrice,
          formattedCompareAtPrice: initialVariant.formattedCompareAtPrice,
          featuredMediaId: initialVariant.featuredMediaId,
          selectedColor: colorInputs.find((input) => input.checked)?.value || '',
          selectedSize: sizeInputs.find((input) => input.checked)?.value || ''
        });
      }

      const pauseInactiveMedia = (index) => {
        items.forEach((item, itemIndex) => {
          if (itemIndex === index) return;

          item.querySelectorAll('video').forEach((video) => video.pause());
          item.querySelectorAll('model-viewer').forEach((model) => {
            if (typeof model.pause === 'function') model.pause();
          });
        });
      };

      const setActive = (index, scrollThumbnail = true) => {
        if (items.length === 0) return;

        activeIndex = Math.min(items.length - 1, Math.max(0, index));

        items.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === activeIndex));
        thumbnails.forEach((thumbnail, thumbnailIndex) => {
          const selected = thumbnailIndex === activeIndex;
          thumbnail.classList.toggle('is-active', selected);
          thumbnail.setAttribute('aria-current', selected ? 'true' : 'false');
        });

        if (current) current.textContent = activeIndex + 1;
        if (previous) previous.disabled = activeIndex === 0;
        if (next) next.disabled = activeIndex === items.length - 1;

        if (scrollThumbnail && thumbnails[activeIndex]) {
          thumbnails[activeIndex].scrollIntoView({
            behavior: reducedMotion ? 'auto' : 'smooth',
            block: 'nearest',
            inline: 'nearest'
          });
        }

        pauseInactiveMedia(activeIndex);
      };

      const scrollToMedia = (index) => {
        const target = items[Math.min(items.length - 1, Math.max(0, index))];
        if (!target) return;

        if (mobileQuery.matches && grid) {
          grid.scrollTo({ left: target.offsetLeft, behavior: reducedMotion ? 'auto' : 'smooth' });
        } else {
          target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
        }

        setActive(index);
      };

      thumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener('click', () => scrollToMedia(Number(thumbnail.dataset.mediaIndex)));
      });

      previous?.addEventListener('click', () => scrollToMedia(activeIndex - 1));
      next?.addEventListener('click', () => scrollToMedia(activeIndex + 1));

      if (grid) {
        grid.addEventListener(
          'scroll',
          () => {
            if (!mobileQuery.matches) return;
            if (scrollFrame) window.cancelAnimationFrame(scrollFrame);

            scrollFrame = window.requestAnimationFrame(() => {
              const gridCenter = grid.getBoundingClientRect().left + grid.clientWidth / 2;
              let nearestIndex = activeIndex;
              let nearestDistance = Number.POSITIVE_INFINITY;

              items.forEach((item, index) => {
                const bounds = item.getBoundingClientRect();
                const distance = Math.abs(bounds.left + bounds.width / 2 - gridCenter);

                if (distance < nearestDistance) {
                  nearestDistance = distance;
                  nearestIndex = index;
                }
              });

              if (nearestIndex !== activeIndex) setActive(nearestIndex);
            });
          },
          { passive: true }
        );
      }

      if (!mobileQuery.matches && 'IntersectionObserver' in window) {
        const activeObserver = new IntersectionObserver(
          (entries) => {
            const visible = entries
              .filter((entry) => entry.isIntersecting)
              .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

            if (visible) setActive(items.indexOf(visible.target));
          },
          { threshold: [0.35, 0.55, 0.75], rootMargin: '-12% 0px -38% 0px' }
        );

        items.forEach((item) => activeObserver.observe(item));
      }

      setActive(activeIndex, false);

      if (mobileQuery.matches && grid && activeIndex > 0 && items[activeIndex]) {
        window.requestAnimationFrame(() => {
          grid.scrollLeft = items[activeIndex].offsetLeft;
        });
      }

      const revealElements = root.querySelectorAll('[data-media-reveal]');

      if (reducedMotion || isThemeEditor || !('IntersectionObserver' in window)) {
        revealElements.forEach((element) => element.classList.add('is-visible'));
      } else {
        root.classList.add('is-motion-ready');

        const revealObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-visible');
              revealObserver.unobserve(entry.target);
            });
          },
          { threshold: 0.06, rootMargin: '0px 0px -5% 0px' }
        );

        revealElements.forEach((element) => revealObserver.observe(element));
      }

      updateStickyPanelMode();

      if (sizeGuideDrawer && sizeGuideOpenButtons.length > 0) {
        const sizeGuidePanel = sizeGuideDrawer.querySelector('.urbx-size-guide-drawer__panel');
        let sizeGuidePreviousFocus = null;
        let sizeGuidePreviousHtmlOverflow = '';
        let sizeGuidePreviousBodyOverflow = '';

        const openSizeGuide = (button) => {
          sizeGuidePreviousFocus = button;
          sizeGuidePreviousHtmlOverflow = document.documentElement.style.overflow;
          sizeGuidePreviousBodyOverflow = document.body.style.overflow;
          sizeGuideDrawer.hidden = false;
          sizeGuideDrawer.setAttribute('aria-hidden', 'false');
          document.documentElement.style.overflow = 'hidden';
          document.body.style.overflow = 'hidden';
          window.requestAnimationFrame(() => {
            sizeGuideDrawer.classList.add('is-open');
            sizeGuideDrawer.querySelector('.urbx-size-guide-drawer__close')?.focus();
          });
        };

        const closeSizeGuide = () => {
          if (!sizeGuideDrawer.classList.contains('is-open')) return;

          sizeGuideDrawer.classList.remove('is-open');
          sizeGuideDrawer.setAttribute('aria-hidden', 'true');
          document.documentElement.style.overflow = sizeGuidePreviousHtmlOverflow;
          document.body.style.overflow = sizeGuidePreviousBodyOverflow;

          window.setTimeout(() => {
            sizeGuideDrawer.hidden = true;
          }, reducedMotion ? 0 : 430);

          sizeGuidePreviousFocus?.focus();
        };

        sizeGuideOpenButtons.forEach((button) => {
          button.addEventListener('click', () => openSizeGuide(button));
        });
        sizeGuideCloseButtons.forEach((button) => button.addEventListener('click', closeSizeGuide));

        sizeGuideDrawer.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            event.preventDefault();
            closeSizeGuide();
            return;
          }

          if (event.key !== 'Tab' || !sizeGuidePanel) return;

          const focusable = Array.from(
            sizeGuidePanel.querySelectorAll(
              'a[href], button:not(:disabled), input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex]:not([tabindex="-1"])'
            )
          ).filter((element) => element.offsetParent !== null);

          if (focusable.length === 0) {
            event.preventDefault();
            sizeGuidePanel.focus();
            return;
          }

          const first = focusable[0];
          const last = focusable[focusable.length - 1];

          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        });
      }

      if (deliveryReturnsDrawer && deliveryReturnsOpenButtons.length > 0) {
        const deliveryReturnsPanel = deliveryReturnsDrawer.querySelector('.urbx-delivery-returns-drawer__panel');
        let deliveryReturnsPreviousFocus = null;
        let deliveryReturnsPreviousHtmlOverflow = '';
        let deliveryReturnsPreviousBodyOverflow = '';

        const openDeliveryReturns = (button) => {
          deliveryReturnsPreviousFocus = button;
          deliveryReturnsPreviousHtmlOverflow = document.documentElement.style.overflow;
          deliveryReturnsPreviousBodyOverflow = document.body.style.overflow;
          deliveryReturnsDrawer.hidden = false;
          deliveryReturnsDrawer.setAttribute('aria-hidden', 'false');
          document.documentElement.style.overflow = 'hidden';
          document.body.style.overflow = 'hidden';
          window.requestAnimationFrame(() => {
            deliveryReturnsDrawer.classList.add('is-open');
            deliveryReturnsDrawer.querySelector('.urbx-delivery-returns-drawer__close')?.focus();
          });
        };

        const closeDeliveryReturns = () => {
          if (!deliveryReturnsDrawer.classList.contains('is-open')) return;

          deliveryReturnsDrawer.classList.remove('is-open');
          deliveryReturnsDrawer.setAttribute('aria-hidden', 'true');
          document.documentElement.style.overflow = deliveryReturnsPreviousHtmlOverflow;
          document.body.style.overflow = deliveryReturnsPreviousBodyOverflow;

          window.setTimeout(() => {
            deliveryReturnsDrawer.hidden = true;
          }, reducedMotion ? 0 : 430);

          deliveryReturnsPreviousFocus?.focus();
        };

        deliveryReturnsOpenButtons.forEach((button) => {
          button.addEventListener('click', () => openDeliveryReturns(button));
        });
        deliveryReturnsCloseButtons.forEach((button) => button.addEventListener('click', closeDeliveryReturns));

        deliveryReturnsDrawer.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            event.preventDefault();
            closeDeliveryReturns();
            return;
          }

          if (event.key !== 'Tab' || !deliveryReturnsPanel) return;

          const focusable = Array.from(
            deliveryReturnsPanel.querySelectorAll(
              'a[href], button:not(:disabled), input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex]:not([tabindex="-1"])'
            )
          ).filter((element) => element.offsetParent !== null);

          if (focusable.length === 0) {
            event.preventDefault();
            deliveryReturnsPanel.focus();
            return;
          }

          const first = focusable[0];
          const last = focusable[focusable.length - 1];

          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        });
      }

      const lightbox = root.querySelector('[data-media-lightbox]');
      const zoomButtons = Array.from(root.querySelectorAll('[data-media-zoom]'));

      if (lightbox && zoomButtons.length > 0) {
        const lightboxImage = lightbox.querySelector('[data-lightbox-image]');
        const lightboxCurrent = lightbox.querySelector('[data-lightbox-current]');
        const lightboxTotal = lightbox.querySelector('[data-lightbox-total]');
        const lightboxPrevious = lightbox.querySelector('[data-lightbox-previous]');
        const lightboxNext = lightbox.querySelector('[data-lightbox-next]');
        const closeButtons = lightbox.querySelectorAll('[data-lightbox-close]');
        let lightboxIndex = 0;
        let previousFocus = null;
        let previousHtmlOverflow = '';
        let previousBodyOverflow = '';

        const updateLightbox = (index) => {
          lightboxIndex = (index + zoomButtons.length) % zoomButtons.length;
          const source = zoomButtons[lightboxIndex];

          if (lightboxImage) {
            lightboxImage.src = source.dataset.zoomSrc || '';
            lightboxImage.alt = source.dataset.zoomAlt || '';
          }
          if (lightboxCurrent) lightboxCurrent.textContent = lightboxIndex + 1;
          if (lightboxTotal) lightboxTotal.textContent = zoomButtons.length;
          if (lightboxPrevious) lightboxPrevious.hidden = zoomButtons.length < 2;
          if (lightboxNext) lightboxNext.hidden = zoomButtons.length < 2;
        };

        const openLightbox = (button) => {
          previousFocus = button;
          previousHtmlOverflow = document.documentElement.style.overflow;
          previousBodyOverflow = document.body.style.overflow;
          updateLightbox(Number(button.dataset.zoomIndex) || 0);
          lightbox.hidden = false;
          lightbox.setAttribute('aria-hidden', 'false');
          document.documentElement.style.overflow = 'hidden';
          document.body.style.overflow = 'hidden';
          window.requestAnimationFrame(() => lightbox.classList.add('is-open'));
          lightbox.querySelector('.urbx-media-lightbox__close')?.focus();
        };

        const closeLightbox = () => {
          if (!lightbox.classList.contains('is-open')) return;

          lightbox.classList.remove('is-open');
          lightbox.setAttribute('aria-hidden', 'true');
          document.documentElement.style.overflow = previousHtmlOverflow;
          document.body.style.overflow = previousBodyOverflow;

          window.setTimeout(() => {
            lightbox.hidden = true;
            if (lightboxImage) lightboxImage.removeAttribute('src');
          }, reducedMotion ? 0 : 360);

          previousFocus?.focus();
        };

        zoomButtons.forEach((button) => button.addEventListener('click', () => openLightbox(button)));
        closeButtons.forEach((button) => button.addEventListener('click', closeLightbox));
        lightboxPrevious?.addEventListener('click', () => updateLightbox(lightboxIndex - 1));
        lightboxNext?.addEventListener('click', () => updateLightbox(lightboxIndex + 1));

        lightbox.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            closeLightbox();
            return;
          }
          if (event.key === 'ArrowLeft') updateLightbox(lightboxIndex - 1);
          if (event.key === 'ArrowRight') updateLightbox(lightboxIndex + 1);

          if (event.key !== 'Tab') return;

          const focusable = Array.from(lightbox.querySelectorAll('button:not([hidden]):not(:disabled)')).filter(
            (element) => element.offsetParent !== null
          );
          if (focusable.length === 0) return;

          const first = focusable[0];
          const last = focusable[focusable.length - 1];

          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        });
      }

      document.addEventListener('variant:change', (event) => {
        if (event.detail?.sectionId && event.detail.sectionId !== root.dataset.sectionId) return;

        const variant = event.detail?.variant;

        if (variant && productPanel) {
          const soldOut = variant.available === false;
          productPanel.dataset.currentVariantId = variant.id || '';

          if (productAvailability) {
            productAvailability.classList.toggle('is-sold-out', soldOut);
          }

          if (productAvailabilityText) {
            productAvailabilityText.textContent = soldOut
              ? 'Currently sold out'
              : 'Available and ready to dispatch';
          }

          if (productSoldOutBadge) {
            productSoldOutBadge.hidden = !soldOut;
          }

          if (productSku && typeof variant.sku === 'string') {
            productSku.textContent = variant.sku;
            if (productSkuRow) productSkuRow.hidden = variant.sku.length === 0;
          }
        }

        if (productCurrentPrice && event.detail?.formattedPrice) {
          productCurrentPrice.textContent = event.detail.formattedPrice;
        }

        if (productComparePrice) {
          const comparePrice = event.detail?.formattedCompareAtPrice || '';
          productComparePrice.textContent = comparePrice;
          productComparePrice.hidden = !comparePrice;
        }

        if (productSaleBadge && typeof event.detail?.onSale === 'boolean') {
          productSaleBadge.hidden = !event.detail.onSale;
        }

        if (productSalePercentage && event.detail?.salePercentage != null) {
          productSalePercentage.textContent = event.detail.salePercentage;
        }

        if (selectedColor && event.detail?.selectedColor) {
          selectedColor.textContent = event.detail.selectedColor;
        }

        if (selectedSize && event.detail?.selectedSize) {
          selectedSize.textContent = event.detail.selectedSize;
        }

        if (variant) {
          updateMainPurchaseActions(variant);
          updateStickyBar(variant, event.detail || {});
        }

        const mediaId = variant?.featured_media?.id || event.detail?.featuredMediaId;
        if (!mediaId) return;

        const targetIndex = items.findIndex((item) => String(item.dataset.mediaId) === String(mediaId));
        if (targetIndex >= 0) scrollToMedia(targetIndex);
      });

      root.urbxProductMediaCleanup = () => {
        if (stickyPanelFrame) window.cancelAnimationFrame(stickyPanelFrame);
        stickyPanelResizeObserver?.disconnect();
        window.removeEventListener('resize', updateStickyPanelMode);
        root.dataset.productMediaInitialised = 'false';
      };
    };

    const initialiseAll = (scope = document) => {
      scope.querySelectorAll(selector).forEach(initialise);
      if (scope.matches && scope.matches(selector)) initialise(scope);
    };

    initialiseAll();

    document.addEventListener('shopify:section:load', (event) => {
      initialiseAll(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll(selector).forEach((root) => {
        root.urbxProductMediaCleanup?.();
      });

      if (event.target.matches?.(selector)) {
        event.target.urbxProductMediaCleanup?.();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["urbx-luxury-product-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-urbx-product-grid]';

    const initialiseCardSwatches = (scope) => {
      scope.querySelectorAll('[data-color-swatches]').forEach((group) => {
        if (group.dataset.swatchesInitialised === 'true') return;

        group.dataset.swatchesInitialised = 'true';

        const card = group.closest('[data-grid-card]');
        const buttons = group.querySelectorAll('[data-color-swatch]');
        const name = group.querySelector('[data-swatch-name]');

        if (!card || buttons.length === 0) return;

        buttons.forEach((button) => {
          button.addEventListener('click', () => {
            buttons.forEach((item) => {
              item.classList.toggle('is-active', item === button);
              item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
            });

            if (name) name.textContent = button.dataset.colorName || '';
            card.dataset.selectedColor = button.dataset.colorName || '';

            const primaryImage = card.querySelector('.urbx-grid-card__image--primary');
            const media = card.querySelector('.urbx-grid-card__media');

            if (primaryImage && button.dataset.imageSrc) {
              primaryImage.src = button.dataset.imageSrc;
              if (button.dataset.imageSrcset) primaryImage.srcset = button.dataset.imageSrcset;
              if (button.dataset.imageAlt) primaryImage.alt = button.dataset.imageAlt;
            }

            media?.classList.remove('urbx-grid-card__media--has-secondary');
            card.classList.add('is-swatch-selected');

            if (button.dataset.variantUrl) {
              card.querySelectorAll('[data-card-product-link]').forEach((link) => {
                link.href = button.dataset.variantUrl;
              });
            }

            const currentPrice = card.querySelector('[data-card-current-price]');
            const comparePrice = card.querySelector('[data-card-compare-price]');

            if (currentPrice && button.dataset.price) currentPrice.textContent = button.dataset.price;

            if (comparePrice) {
              const comparison = button.dataset.comparePrice || '';
              comparePrice.textContent = comparison;
              comparePrice.hidden = comparison.length === 0;
            }

            const availability = card.querySelector('[data-card-availability]');
            const availabilityText = card.querySelector('[data-card-availability-text]');
            const available = button.dataset.available === 'true';

            if (availability) availability.classList.toggle('is-sold-out', !available);
            if (availabilityText) availabilityText.textContent = available ? 'Available' : 'Sold out';

            const soldOutBadge = card.querySelector('[data-sold-out-badge]');
            const saleBadge = card.querySelector('[data-sale-badge]');

            if (soldOutBadge) soldOutBadge.hidden = available;

            if (saleBadge) {
              const saleLabel = button.dataset.saleBadge || '';
              saleBadge.textContent = saleLabel;
              saleBadge.hidden = saleLabel.length === 0;
            }
          });
        });
      });
    };

    const initialiseQuickAdd = (root) => {
      const drawer = root.querySelector('[data-quick-add-drawer]');

      if (!drawer || drawer.dataset.quickAddInitialised === 'true') return;

      drawer.dataset.quickAddInitialised = 'true';

      const panel = drawer.querySelector('.urbx-quick-add__panel');
      const title = drawer.querySelector('[data-quick-add-title]');
      const image = drawer.querySelector('[data-quick-add-image]');
      const colour = drawer.querySelector('[data-quick-add-colour]');
      const price = drawer.querySelector('[data-quick-add-price]');
      const sizes = drawer.querySelector('[data-quick-add-sizes]');
      const selection = drawer.querySelector('[data-quick-add-selection]');
      const status = drawer.querySelector('[data-quick-add-status]');
      const submit = drawer.querySelector('[data-quick-add-submit]');
      const submitLabel = drawer.querySelector('[data-quick-add-submit-label]');
      const viewCart = drawer.querySelector('[data-quick-add-view-cart]');
      const closeButtons = drawer.querySelectorAll('[data-quick-add-close]');
      let selectedVariantId = null;
      let previousFocus = null;
      let previousHtmlOverflow = '';
      let previousBodyOverflow = '';

      if (!panel || !sizes || !submit || !submitLabel) return;

      const setSubmitState = (label, disabled) => {
        submitLabel.textContent = label;
        submit.disabled = disabled;
      };

      const closeDrawer = () => {
        if (!drawer.classList.contains('is-open')) return;

        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = previousHtmlOverflow;
        document.body.style.overflow = previousBodyOverflow;

        if (previousFocus) {
          previousFocus.setAttribute('aria-expanded', 'false');
          previousFocus.focus();
        }
      };

      const selectSize = (button) => {
        if (button.disabled) return;

        sizes.querySelectorAll('[data-quick-add-size]').forEach((item) => {
          const selected = item === button;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });

        selectedVariantId = button.dataset.variantId || null;
        if (selection) selection.textContent = button.dataset.size || 'Selected';
        if (price && button.dataset.price) price.textContent = button.dataset.price;
        if (status) {
          status.textContent = '';
          status.classList.remove('is-error');
        }
        if (viewCart) viewCart.hidden = true;
        setSubmitState('Add to bag', !selectedVariantId);
      };

      const openDrawer = (trigger) => {
        const card = trigger.closest('[data-grid-card]');
        const template = card?.querySelector('[data-quick-add-template]');

        if (!card || !template) return;

        selectedVariantId = null;
        previousFocus = trigger;
        previousHtmlOverflow = document.documentElement.style.overflow;
        previousBodyOverflow = document.body.style.overflow;

        const selectedColour = (card.dataset.selectedColor || '').trim();
        const selectedColourKey = selectedColour.toLowerCase();
        const content = template.content.cloneNode(true);
        const optionButtons = Array.from(content.querySelectorAll('[data-quick-add-size]'));
        const retainedSizes = new Set();

        optionButtons.forEach((button) => {
          const buttonColour = (button.dataset.color || '').trim();
          const buttonColourKey = buttonColour.toLowerCase();
          const sizeKey = (button.dataset.size || '').trim().toLowerCase();

          if (selectedColourKey && buttonColourKey && buttonColourKey !== selectedColourKey) {
            button.remove();
            return;
          }

          if (retainedSizes.has(sizeKey)) {
            button.remove();
            return;
          }

          retainedSizes.add(sizeKey);
          button.setAttribute('aria-pressed', 'false');
          button.addEventListener('click', () => selectSize(button));
        });

        sizes.replaceChildren(content);

        const productTitle = card.querySelector('.urbx-grid-card__title')?.textContent.trim() || 'Quick add';
        const productImage = card.querySelector('.urbx-grid-card__image--primary');
        const productPrice = card.querySelector('[data-card-current-price]')?.textContent.trim() || '';

        if (title) title.textContent = productTitle;
        if (colour) colour.textContent = selectedColour ? `Colour / ${selectedColour}` : '';
        if (price) price.textContent = productPrice;
        if (selection) selection.textContent = 'None selected';
        if (status) {
          status.textContent = '';
          status.classList.remove('is-error');
        }
        if (viewCart) viewCart.hidden = true;

        if (image) {
          const source = productImage?.currentSrc || productImage?.src || '';
          image.hidden = source.length === 0;
          image.src = source;
          image.alt = productTitle;
        }

        setSubmitState('Select a size', true);

        const availableButtons = Array.from(sizes.querySelectorAll('[data-quick-add-size]:not(:disabled)'));

        if (availableButtons.length === 0 && status) {
          status.textContent = selectedColour ? 'This colour is currently unavailable.' : 'This item is currently unavailable.';
        } else if (availableButtons.length === 1) {
          selectSize(availableButtons[0]);
        }

        trigger.setAttribute('aria-expanded', 'true');
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        drawer.querySelector('.urbx-quick-add__close')?.focus();
      };

      root.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-quick-add-open]');

        if (trigger && root.contains(trigger)) openDrawer(trigger);
      });

      closeButtons.forEach((button) => button.addEventListener('click', closeDrawer));

      drawer.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closeDrawer();
          return;
        }

        if (event.key !== 'Tab') return;

        const focusable = Array.from(
          panel.querySelectorAll('a[href], button:not(:disabled), [tabindex]:not([tabindex="-1"])')
        ).filter((element) => !element.hidden && element.offsetParent !== null);

        if (focusable.length === 0) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });

      submit.addEventListener('click', async () => {
        if (!selectedVariantId) return;

        setSubmitState('Adding…', true);
        if (status) {
          status.textContent = '';
          status.classList.remove('is-error');
        }

        try {
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              items: [{ id: Number(selectedVariantId), quantity: 1 }]
            })
          });

          const data = await response.json();

          if (!response.ok) {
            throw new Error(data.description || data.message || 'This size could not be added.');
          }

          if (status) status.textContent = 'Added to your bag.';
          setSubmitState('Added', true);
          if (viewCart) viewCart.hidden = false;

          document.dispatchEvent(
            new CustomEvent('cart:updated', {
              bubbles: true,
              detail: { source: 'urbx-quick-add', items: data.items || [] }
            })
          );
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

          try {
            const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`, {
              headers: { Accept: 'application/json' }
            });
            const cart = await cartResponse.json();

            document.dispatchEvent(
              new CustomEvent('cart:update', {
                bubbles: true,
                detail: { source: 'urbx-quick-add', cart }
              })
            );

            document.querySelectorAll('[data-cart-count]').forEach((count) => {
              count.textContent = cart.item_count;
            });
          } catch (cartError) {
            // The product is already added; a cart refresh failure should not reverse that success.
          }
        } catch (error) {
          if (status) {
            status.textContent = error.message || 'This size could not be added.';
            status.classList.add('is-error');
          }
          setSubmitState('Try again', false);
        }
      });
    };

    const initialiseLoadMore = (root) => {
      const loadMore = root.querySelector('[data-load-more]');
      const gridItems = root.querySelector('[data-product-grid-items]');

      if (!loadMore || !gridItems || loadMore.dataset.loadMoreInitialised === 'true') return;

      loadMore.dataset.loadMoreInitialised = 'true';

      const button = loadMore.querySelector('[data-load-more-button]');
      const label = loadMore.querySelector('[data-load-more-label]');
      const count = loadMore.querySelector('[data-load-more-count]');
      const progress = loadMore.querySelector('[data-load-more-progress]');
      const status = loadMore.querySelector('[data-load-more-status]');

      if (!button || !label) return;

      const updateProgress = (loaded, total) => {
        const percentage = total > 0 ? Math.min(100, Math.max(0, (loaded / total) * 100)) : 100;

        if (count) count.textContent = loaded;
        if (progress) progress.style.setProperty('--urbx-load-progress', `${percentage}%`);
      };

      const setLoading = (loading) => {
        button.disabled = loading;
        button.classList.toggle('is-loading', loading);
        button.setAttribute('aria-busy', loading ? 'true' : 'false');
        label.textContent = loading ? 'Loading styles' : 'Load more';
      };

      button.addEventListener('click', async () => {
        const nextPageUrl = loadMore.dataset.nextPageUrl;

        if (!nextPageUrl || button.disabled) return;

        setLoading(true);
        if (status) {
          status.textContent = '';
          status.classList.remove('is-error');
        }

        try {
          const response = await fetch(nextPageUrl, {
            headers: {
              Accept: 'text/html',
              'X-Requested-With': 'XMLHttpRequest'
            }
          });

          if (!response.ok) throw new Error('The next products could not be loaded.');

          const html = await response.text();
          const parsedDocument = new DOMParser().parseFromString(html, 'text/html');
          const nextRoot = parsedDocument.getElementById(root.id);
          const nextGridItems = nextRoot?.querySelector('[data-product-grid-items]');
          const nextLoadMore = nextRoot?.querySelector('[data-load-more]');

          if (!nextGridItems || !nextLoadMore) {
            throw new Error('The next products could not be found.');
          }

          const incomingCards = Array.from(nextGridItems.children).filter((item) => item.matches('[data-grid-card]'));

          if (incomingCards.length === 0) throw new Error('No additional products were returned.');

          incomingCards.forEach((card) => {
            card.classList.remove('is-visible');
            card.classList.add('urbx-grid-card--appended');
            gridItems.appendChild(card);
          });

          initialiseCardSwatches(gridItems);

          const loadedCount = Number(nextLoadMore.dataset.loadedCount) || gridItems.querySelectorAll('[data-grid-card]').length;
          const totalProducts = Number(nextLoadMore.dataset.totalProducts) || Number(loadMore.dataset.totalProducts) || loadedCount;
          const followingPageUrl = nextLoadMore.dataset.nextPageUrl || '';

          loadMore.dataset.loadedCount = loadedCount;
          loadMore.dataset.totalProducts = totalProducts;
          loadMore.dataset.nextPageUrl = followingPageUrl;
          updateProgress(loadedCount, totalProducts);

          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          if (reducedMotion) {
            incomingCards.forEach((card) => {
              card.classList.add('is-visible');
              card.classList.remove('urbx-grid-card--appended');
            });
          } else {
            root.classList.add('urbx-product-grid--motion-ready');
            window.requestAnimationFrame(() => {
              window.requestAnimationFrame(() => {
                incomingCards.forEach((card, index) => {
                  window.setTimeout(() => {
                    card.classList.add('is-visible');
                    card.classList.remove('urbx-grid-card--appended');
                  }, index * 65);
                });
              });
            });
          }

          if (followingPageUrl) {
            setLoading(false);
            if (status) {
              status.textContent = `${incomingCards.length} more styles loaded. ${loadedCount} of ${totalProducts} are visible.`;
            }
          } else {
            button.hidden = true;
            button.disabled = false;
            button.classList.remove('is-loading');
            button.removeAttribute('aria-busy');
            loadMore.classList.add('is-complete');

            if (status) {
              status.textContent = `All ${totalProducts} styles are now visible.`;
              status.focus({ preventScroll: true });
            }
          }
        } catch (error) {
          setLoading(false);
          label.textContent = 'Try again';

          if (status) {
            status.textContent = error.message || 'The next products could not be loaded. Please try again.';
            status.classList.add('is-error');
          }
        }
      });
    };

    const initialiseProductGrid = (root) => {
      if (!root || root.dataset.urbxGridInitialised === 'true') return;

      root.dataset.urbxGridInitialised = 'true';

      initialiseCardSwatches(root);
      initialiseQuickAdd(root);
      initialiseLoadMore(root);

      const cards = root.querySelectorAll('[data-grid-card]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reducedMotion || !('IntersectionObserver' in window)) {
        cards.forEach((card) => card.classList.add('is-visible'));
        return;
      }

      root.classList.add('urbx-product-grid--motion-ready');

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.08, rootMargin: '0px 0px -4% 0px' }
      );

      cards.forEach((card) => observer.observe(card));
    };

    const initialiseAll = (scope = document) => {
      scope.querySelectorAll(selector).forEach(initialiseProductGrid);
      if (scope.matches && scope.matches(selector)) initialiseProductGrid(scope);
    };

    initialiseAll();

    document.addEventListener('shopify:section:load', (event) => {
      initialiseAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["urbx-motion-marquee"] && !Shopify.designMode) return;
  try {
    
  class UrbxMotionMarquee extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.toggleButton = this.querySelector('[data-marquee-toggle]');
      this.toggleHandler = () => this.toggleMotion();
      this.toggleButton?.addEventListener('click', this.toggleHandler);
    }

    disconnectedCallback() {
      this.toggleButton?.removeEventListener('click', this.toggleHandler);
    }

    toggleMotion() {
      const paused = this.classList.toggle('is-paused');
      const icon = this.toggleButton?.querySelector('[data-marquee-icon]');
      if (this.toggleButton) {
        const label = paused ? this.toggleButton.dataset.playLabel : this.toggleButton.dataset.pauseLabel;
        this.toggleButton.setAttribute('aria-label', label || '');
      }
      if (icon) icon.textContent = paused ? '\u25B6' : '\u275A\u275A';
    }
  }

  if (!customElements.get('urbx-motion-marquee')) {
    customElements.define('urbx-motion-marquee', UrbxMotionMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["urbx-performance-promise-strip"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-urbx-promise-strip]';

    const initialisePromiseStrip = (root) => {
      if (!root || root.dataset.urbxPromiseInitialised === 'true') return;

      root.dataset.urbxPromiseInitialised = 'true';

      const items = root.querySelectorAll('[data-promise-reveal]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reducedMotion || !('IntersectionObserver' in window)) {
        items.forEach((item) => item.classList.add('is-visible'));
        return;
      }

      root.classList.add('urbx-promise-strip--motion-ready');

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.14, rootMargin: '0px 0px -6% 0px' }
      );

      items.forEach((item) => observer.observe(item));
    };

    const initialiseAll = (scope = document) => {
      scope.querySelectorAll(selector).forEach(initialisePromiseStrip);
      if (scope.matches && scope.matches(selector)) initialisePromiseStrip(scope);
    };

    initialiseAll();

    document.addEventListener('shopify:section:load', (event) => {
      initialiseAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["urbx-product-performance-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('urbx-performance-story')) {
    class UrbxPerformanceStory extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        if (!('IntersectionObserver' in window)) {
          this.classList.add('is-visible');
          return;
        }

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              this.classList.add('is-visible');
              observer.disconnect();
            });
          },
          { threshold: 0.14 }
        );

        observer.observe(this);
      }
    }

    customElements.define('urbx-performance-story', UrbxPerformanceStory);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["urbx-recently-viewed-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-urbx-recently-viewed]';
    const storageKey = 'urbx-recently-viewed-products-v1';
    const storageLimit = 20;
    const handlePattern = /^[a-z0-9][a-z0-9-]*$/i;

    const readHistory = () => {
      try {
        const stored = JSON.parse(window.localStorage.getItem(storageKey) || '[]');

        if (!Array.isArray(stored)) return [];
        return stored.filter((handle) => typeof handle === 'string' && handlePattern.test(handle));
      } catch (error) {
        return [];
      }
    };

    const writeHistory = (handles) => {
      try {
        window.localStorage.setItem(storageKey, JSON.stringify(handles.slice(0, storageLimit)));
      } catch (error) {
        // Storage can be unavailable in strict privacy modes; the section remains safely hidden.
      }
    };

    const imageUrl = (source, width) => {
      if (!source) return '';

      try {
        const url = new URL(source, window.location.href);
        url.searchParams.set('width', width);
        return url.href;
      } catch (error) {
        return source;
      }
    };

    const getProductPrice = (product) => {
      const variantPrices = Array.isArray(product.variants)
        ? product.variants.map((variant) => Number(variant.price)).filter(Number.isFinite)
        : [];
      const directPrice = Number(product.price);
      const price = Number.isFinite(directPrice) ? directPrice : Math.min(...variantPrices);
      const comparePrices = Array.isArray(product.variants)
        ? product.variants.map((variant) => Number(variant.compare_at_price)).filter(Number.isFinite)
        : [];
      const directComparePrice = product.compare_at_price == null ? Number.NaN : Number(product.compare_at_price);
      const compareAtPrice = Number.isFinite(directComparePrice) ? directComparePrice : Math.max(0, ...comparePrices);

      return {
        price: Number.isFinite(price) ? price : 0,
        compareAtPrice,
        varies: new Set(variantPrices).size > 1
      };
    };

    const initialise = async (root) => {
      if (!root || root.dataset.recentInitialised === 'true') return;

      root.dataset.recentInitialised = 'true';

      const currentHandle = (root.dataset.currentProduct || '').trim();
      const maxProducts = Number(root.dataset.maxProducts) || 6;
      const list = root.querySelector('[data-recent-list]');
      const viewport = root.querySelector('[data-recent-viewport]');
      const template = root.querySelector('[data-recent-card-template]');
      const previous = root.querySelector('[data-recent-previous]');
      const next = root.querySelector('[data-recent-next]');
      const navigation = root.querySelector('[data-recent-navigation]');
      const status = root.querySelector('[data-recent-status]');
      const empty = root.querySelector('[data-recent-empty]');

      if (!list || !viewport || !template) return;

      const history = readHistory();
      const displayHandles = history.filter((handle) => handle !== currentHandle).slice(0, maxProducts);

      if (currentHandle && handlePattern.test(currentHandle)) {
        writeHistory([currentHandle, ...history.filter((handle) => handle !== currentHandle)]);
      }

      const showEmptyState = () => {
        list.setAttribute('aria-busy', 'false');

        if (window.Shopify?.designMode) {
          root.hidden = false;
          if (empty) empty.hidden = false;
          viewport.hidden = true;
          if (navigation) navigation.hidden = true;
        } else {
          root.hidden = true;
        }
      };

      if (displayHandles.length === 0) {
        showEmptyState();
        return;
      }

      root.hidden = false;
      list.setAttribute('aria-busy', 'true');

      const storefrontRoot = window.Shopify?.routes?.root || '/';
      const requests = displayHandles.map(async (handle) => {
        const response = await fetch(`${storefrontRoot}products/${encodeURIComponent(handle)}.js`, {
          headers: { Accept: 'application/json' }
        });

        if (!response.ok) throw new Error(`Product ${handle} is unavailable.`);
        return response.json();
      });

      const results = await Promise.allSettled(requests);
      const products = results
        .filter((result) => result.status === 'fulfilled')
        .map((result) => result.value);

      if (products.length === 0) {
        showEmptyState();
        return;
      }

      const currencyCode = root.dataset.currencyCode || 'GBP';
      const locale = document.documentElement.lang || 'en-GB';
      const moneyFormatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currencyCode
      });
      const formatMoney = (amount) => moneyFormatter.format(Number(amount || 0) / 100);
      const showVendor = root.dataset.showVendor === 'true';
      const showProductType = root.dataset.showProductType === 'true';
      const showColourCount = root.dataset.showColourCount === 'true';
      const showCardNumbers = root.dataset.showCardNumbers === 'true';
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      list.replaceChildren();

      products.forEach((product, index) => {
        const fragment = template.content.cloneNode(true);
        const card = fragment.querySelector('[data-recent-card]');
        const links = fragment.querySelectorAll('[data-recent-link], [data-recent-title-link]');
        const mediaLink = fragment.querySelector('[data-recent-link]');
        const titleLink = fragment.querySelector('[data-recent-title-link]');
        const primaryImage = fragment.querySelector('[data-recent-image]');
        const secondaryImage = fragment.querySelector('[data-recent-secondary-image]');
        const classification = fragment.querySelector('[data-recent-classification]');
        const colours = fragment.querySelector('[data-recent-colours]');
        const price = fragment.querySelector('[data-recent-price]');
        const comparePrice = fragment.querySelector('[data-recent-compare-price]');
        const soldOut = fragment.querySelector('[data-recent-sold-out]');
        const sale = fragment.querySelector('[data-recent-sale]');
        const number = fragment.querySelector('[data-recent-number]');
        const productHandle = String(product.handle || displayHandles[index] || '');
        const productUrl = product.url || `${storefrontRoot}products/${encodeURIComponent(productHandle)}`;
        const images = Array.isArray(product.images) ? product.images : [];
        const primarySource = images[0] || product.featured_image || '';
        const secondarySource = images[1] || '';
        const pricing = getProductPrice(product);
        const onSale = pricing.compareAtPrice > pricing.price;
        const available = product.available !== false;

        links.forEach((link) => {
          link.href = productUrl;
        });

        if (mediaLink) mediaLink.setAttribute('aria-label', `View ${product.title}`);
        if (titleLink) titleLink.textContent = product.title || 'Product';

        if (primaryImage && primarySource) {
          primaryImage.src = imageUrl(primarySource, 900);
          primaryImage.srcset = `${imageUrl(primarySource, 420)} 420w, ${imageUrl(primarySource, 640)} 640w, ${imageUrl(primarySource, 900)} 900w, ${imageUrl(primarySource, 1200)} 1200w`;
          primaryImage.alt = product.title || '';
        }

        if (secondaryImage && secondarySource) {
          secondaryImage.src = imageUrl(secondarySource, 900);
          secondaryImage.srcset = `${imageUrl(secondarySource, 420)} 420w, ${imageUrl(secondarySource, 640)} 640w, ${imageUrl(secondarySource, 900)} 900w`;
          secondaryImage.hidden = false;
        }

        const classificationParts = [];
        if (showVendor && product.vendor) classificationParts.push(product.vendor);
        if (showProductType && product.type) classificationParts.push(product.type);
        if (classification) classification.textContent = classificationParts.join(' / ');

        if (showColourCount && colours) {
          const colourOption = Array.isArray(product.options)
            ? product.options.find((option) => ['color', 'colour'].includes(String(option.name || '').toLowerCase()))
            : null;
          const colourCount = Array.isArray(colourOption?.values) ? colourOption.values.length : 0;

          if (colourCount > 0) {
            colours.textContent = `${colourCount} ${colourCount === 1 ? 'colour' : 'colours'}`;
            colours.hidden = false;
          }
        }

        if (price) price.textContent = `${pricing.varies ? 'From ' : ''}${formatMoney(pricing.price)}`;
        if (comparePrice && onSale) {
          comparePrice.textContent = formatMoney(pricing.compareAtPrice);
          comparePrice.hidden = false;
        }

        if (soldOut) soldOut.hidden = available;
        if (sale && onSale) {
          const percentage = Math.round(((pricing.compareAtPrice - pricing.price) / pricing.compareAtPrice) * 100);
          sale.textContent = `-${percentage}%`;
          sale.hidden = false;
        }

        if (number && showCardNumbers) number.textContent = String(index + 1).padStart(2, '0');

        list.appendChild(fragment);

        if (card) {
          window.setTimeout(() => card.classList.add('is-visible'), reducedMotion ? 0 : index * 75 + 40);
        }
      });

      list.setAttribute('aria-busy', 'false');
      if (empty) empty.hidden = true;
      if (status) status.textContent = `${products.length} recently viewed ${products.length === 1 ? 'product' : 'products'} loaded.`;

      const updateNavigation = () => {
        const maximum = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
        const atStart = viewport.scrollLeft <= 2;
        const atEnd = viewport.scrollLeft >= maximum - 2;

        if (previous) previous.disabled = atStart;
        if (next) next.disabled = atEnd;
        if (navigation) navigation.classList.toggle('is-static', maximum <= 2);
      };

      const scrollRail = (direction) => {
        const firstCard = list.querySelector('[data-recent-card]');
        const gap = Number.parseFloat(window.getComputedStyle(list).gap) || 0;
        const distance = (firstCard?.getBoundingClientRect().width || viewport.clientWidth * 0.8) + gap;

        viewport.scrollBy({ left: direction * distance, behavior: reducedMotion ? 'auto' : 'smooth' });
      };

      previous?.addEventListener('click', () => scrollRail(-1));
      next?.addEventListener('click', () => scrollRail(1));

      let navigationFrame = null;
      viewport.addEventListener(
        'scroll',
        () => {
          if (navigationFrame) window.cancelAnimationFrame(navigationFrame);
          navigationFrame = window.requestAnimationFrame(updateNavigation);
        },
        { passive: true }
      );
      window.addEventListener('resize', updateNavigation, { passive: true });
      window.requestAnimationFrame(updateNavigation);
    };

    const initialiseAll = (scope = document) => {
      scope.querySelectorAll(selector).forEach(initialise);
      if (scope.matches && scope.matches(selector)) initialise(scope);
    };

    initialiseAll();

    document.addEventListener('shopify:section:load', (event) => {
      initialiseAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["urbx-recommended-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('urbx-recommended-products')) {
    class UrbxRecommendedProducts extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.addedLabel = this.dataset.addedLabel || 'Added';
        this.loadingLabel = this.dataset.loadingLabel || 'Adding';
        this.errorLabel = this.dataset.errorLabel || 'Unable to add this item';
        this.handleClick = this.handleClick.bind(this);
        this.addEventListener('click', this.handleClick);

        if (this.dataset.loaded === 'true') {
          this.initializeContent();
        } else {
          this.observeForRecommendations();
        }
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        if (this.loadObserver) this.loadObserver.disconnect();
        if (this.revealObserver) this.revealObserver.disconnect();
      }

      observeForRecommendations() {
        if (!('IntersectionObserver' in window)) {
          this.loadRecommendations();
          return;
        }

        this.loadObserver = new IntersectionObserver((entries) => {
          if (!entries[0].isIntersecting) return;
          this.loadObserver.disconnect();
          this.loadRecommendations();
        }, { rootMargin: '0px 0px 400px 0px' });

        this.loadObserver.observe(this);
      }

      async loadRecommendations() {
        const url = this.dataset.url;
        if (!url) {
          this.hideWhenEmpty();
          return;
        }

        try {
          const response = await fetch(url, { headers: { Accept: 'text/html' } });
          if (!response.ok) throw new Error(this.errorLabel);

          const text = await response.text();
          const container = document.createElement('div');
          container.innerHTML = text;
          const returnedSection = container.querySelector('urbx-recommended-products');
          const returnedContent = returnedSection ? returnedSection.querySelector('[data-recommended-content]') : null;
          const currentContent = this.querySelector('[data-recommended-content]');

          if (!returnedContent || !currentContent) {
            this.hideWhenEmpty();
            return;
          }

          currentContent.innerHTML = returnedContent.innerHTML;
          this.dataset.loaded = 'true';
          this.classList.remove('is-loading');
          this.initializeContent();
        } catch (error) {
          this.classList.remove('is-loading');
          this.hideWhenEmpty();
        }
      }

      initializeContent() {
        this.status = this.querySelector('[data-recommended-status]');
        const cards = this.querySelectorAll('.urbx-recommended-products__card:not(.urbx-recommended-products__card--skeleton)');

        if (!cards.length) {
          this.hideWhenEmpty();
          return;
        }

        this.hidden = false;
        this.setupReveal();
      }

      hideWhenEmpty() {
        if (this.dataset.designMode === 'true') return;
        this.hidden = true;
      }

      setupReveal() {
        const items = Array.from(this.querySelectorAll('[data-recommended-reveal]'));
        if (!items.length) return;

        if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          items.forEach((item) => item.classList.add('is-visible'));
          return;
        }

        this.classList.add('is-ready');
        this.revealObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            this.revealObserver.unobserve(entry.target);
          });
        }, { threshold: 0.12 });

        items.forEach((item) => this.revealObserver.observe(item));
      }

      handleClick(event) {
        const button = event.target.closest('[data-recommended-quick-add]');
        if (!button || !this.contains(button)) return;
        this.addToCart(button);
      }

      async addToCart(button) {
        const variantId = Number(button.dataset.variantId);
        const label = button.querySelector('[data-recommended-action-label]');
        const defaultLabel = button.dataset.defaultLabel || (label ? label.textContent : '');

        if (!variantId || button.disabled || !label) return;

        button.disabled = true;
        button.classList.add('is-loading');
        label.textContent = this.loadingLabel;

        try {
          const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          });

          if (!response.ok) {
            const payload = await response.json().catch(() => ({}));
            throw new Error(payload.description || this.errorLabel);
          }

          const payload = await response.json();
          button.classList.remove('is-loading');
          button.classList.add('is-added');
          label.textContent = this.addedLabel;
          this.announce(this.addedLabel);

          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:updated', {
            bubbles: true,
            detail: { source: 'urbx-recommended-products', payload }
          }));

          await this.refreshCartCount(root);

          window.setTimeout(() => {
            button.classList.remove('is-added');
            label.textContent = defaultLabel;
            button.disabled = false;
          }, 1600);
        } catch (error) {
          button.classList.remove('is-loading');
          label.textContent = defaultLabel;
          button.disabled = false;
          this.announce(error.message || this.errorLabel);
        }
      }

      async refreshCartCount(root) {
        try {
          const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
          if (!response.ok) return;

          const cart = await response.json();
          const countTargets = document.querySelectorAll('[data-cart-count], [data-cart-count-bubble], .cart-count-bubble span');
          countTargets.forEach((target) => {
            target.textContent = cart.item_count;
            target.removeAttribute('hidden');
          });
        } catch (error) {
          return;
        }
      }

      announce(message) {
        if (!this.status) return;
        this.status.textContent = '';
        window.requestAnimationFrame(() => {
          this.status.textContent = message;
        });
      }
    }

    customElements.define('urbx-recommended-products', UrbxRecommendedProducts);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["urbx-sticky-filter-sort-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-urbx-filter-bar]';

    const initialiseFilterBar = (root) => {
      if (!root || root.dataset.urbxFilterInitialised === 'true') return;

      const form = root.querySelector('[data-filter-form]');
      const sortSelect = root.querySelector('[data-sort-select]');
      const openButton = root.querySelector('[data-filter-open]');
      const drawer = root.querySelector('[data-filter-drawer]');
      const closeButtons = root.querySelectorAll('[data-filter-close]');
      const desktopDetails = root.querySelectorAll('[data-filter-details]');
      const autoApply = root.dataset.autoApply === 'true';

      if (!form) return;

      root.dataset.urbxFilterInitialised = 'true';

      sortSelect?.addEventListener('change', () => form.requestSubmit());

      form.addEventListener('submit', () => {
        const mobileView = window.matchMedia('(max-width: 849px)').matches;

        form.querySelectorAll('[data-filter-surface]').forEach((input) => {
          const inactiveSurface = mobileView
            ? input.dataset.filterSurface === 'desktop'
            : input.dataset.filterSurface === 'mobile';

          if (inactiveSurface) input.disabled = true;
        });
      });

      if (autoApply) {
        root.querySelectorAll('[data-filter-input]').forEach((input) => {
          if (input.type === 'number') return;
          input.addEventListener('change', () => form.requestSubmit());
        });
      }

      desktopDetails.forEach((details) => {
        details.addEventListener('toggle', () => {
          if (!details.open) return;
          desktopDetails.forEach((other) => {
            if (other !== details) other.removeAttribute('open');
          });
        });
      });

      document.addEventListener('click', (event) => {
        if (!root.contains(event.target)) {
          desktopDetails.forEach((details) => details.removeAttribute('open'));
        }
      });

      if (!openButton || !drawer) return;

      let previousFocus = null;
      let previousOverflow = '';

      const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';

      const openDrawer = () => {
        previousFocus = document.activeElement;
        previousOverflow = document.documentElement.style.overflow;
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        openButton.setAttribute('aria-expanded', 'true');
        document.documentElement.style.overflow = 'hidden';
        window.setTimeout(() => drawer.querySelector('[data-filter-close]')?.focus(), 30);
      };

      const closeDrawer = () => {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        openButton.setAttribute('aria-expanded', 'false');
        document.documentElement.style.overflow = previousOverflow;
        previousFocus?.focus();
      };

      openButton.addEventListener('click', openDrawer);
      closeButtons.forEach((button) => button.addEventListener('click', closeDrawer));

      drawer.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeDrawer();
          return;
        }

        if (event.key !== 'Tab') return;

        const focusable = Array.from(drawer.querySelectorAll(focusableSelector)).filter(
          (element) => element.offsetParent !== null
        );

        if (focusable.length === 0) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    };

    const initialiseAll = (scope = document) => {
      scope.querySelectorAll(selector).forEach(initialiseFilterBar);
      if (scope.matches && scope.matches(selector)) initialiseFilterBar(scope);
    };

    initialiseAll();

    document.addEventListener('shopify:section:load', (event) => {
      initialiseAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
